import React, { useState } from "react";
import { useNavigate } from "react-router-dom";
import { toast } from "sonner";
import { useAuth } from "@/context/AuthContext";
import { apiError } from "@/lib/api";
import { Input } from "@/components/ui/input";
import { Label } from "@/components/ui/label";

const PORTAL_META = {
  admin: { eyebrow: "Staff", title: "Staff Login", idLabel: "Email" },
  trade: { eyebrow: "Trade Account", title: "Trade Login", idLabel: "Username or email" },
};

export default function Login({ portal }) {
  const { login } = useAuth();
  const nav = useNavigate();
  const meta = PORTAL_META[portal] || { eyebrow: "Account", title: "Login", idLabel: "Email or username" };
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [loading, setLoading] = useState(false);

  const submit = async (e) => {
    e.preventDefault();
    setLoading(true);
    try {
      const u = await login(email, password, portal);
      toast.success(`Welcome back, ${u.name}`);
      nav(u.role === "admin" ? "/admin" : u.role === "dropship" ? "/trade" : "/shop");
    } catch (err) {
      toast.error(apiError(err));
    } finally { setLoading(false); }
  };

  return (
    <div className="mx-auto flex max-w-md flex-col px-6 py-20">
      <div className="mono text-[11px] uppercase tracking-[0.25em] text-muted-foreground">{meta.eyebrow}</div>
      <h1 className="mt-3 font-heading text-4xl font-black tracking-tighter" data-testid="login-title">{meta.title}</h1>
      <form onSubmit={submit} className="mt-8 space-y-4">
        <div>
          <Label className="mono text-[10px] uppercase tracking-[0.15em] text-muted-foreground">{meta.idLabel}</Label>
          <Input data-testid="login-email" type="text" autoComplete="username" value={email} onChange={(e) => setEmail(e.target.value)} className="mt-1.5 rounded-none" required />
        </div>
        <div>
          <Label className="mono text-[10px] uppercase tracking-[0.15em] text-muted-foreground">Password</Label>
          <Input data-testid="login-password" type="password" autoComplete="current-password" value={password} onChange={(e) => setPassword(e.target.value)} className="mt-1.5 rounded-none" required />
        </div>
        <button data-testid="login-submit" disabled={loading} className="w-full bg-foreground py-3.5 text-sm font-medium text-background transition-transform enabled:hover:-translate-y-0.5 disabled:opacity-40">
          {loading ? "…" : "Login"}
        </button>
      </form>
    </div>
  );
}
